import env from '@polleverywhere/core/lib/env'
import Chain from '@polleverywhere/core/lib/ajax/chain'

export const $ajax = (new Chain()).ajax

export function generateCrud (apiPath) {
  const uri = env.get('api_url').pathname(apiPath)

  return {
    /**
     * Send create request with the following body and optional params.
     * @param {Object} body Request body/payload to send.
     * @param {Object} options Fetch API options
     * @param {Object} options.query Optional query params to the request URL.
     * @return {Promise} POST request
     */
    create (body = {}, options = {}) {
      const { query = {}, headers = {} } = options

      return $ajax({
        url: uri.query(query).toString(),
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(body),
        headers
      })
    },

    /**
     * Send read request with the following query params.
     * @param {Object} body Query params to add to the request URL
     * @param {Object} options Fetch API options
     * @return {Promise} GET request
     */
    read (body = {}, options = {}) {
      return $ajax({
        url: uri.query(body).toString(),
        method: 'GET'
      })
    },

    /**
     * Send update request with the following body and optional params.
     * @param {Object} body Request body/payload to send.
     * @param {Object} options Fetch API options
     * @param {Object} options.query Optional query params to the request URL.
     * @return {Promise} PUT request
     */
    update (body = {}, options = {}) {
      const { query = {} } = options

      return $ajax({
        url: uri.query(query).toString(),
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(body),
        headers: {
          'X-HTTP-Method-Override': 'PATCH'
        }
      })
    },

    /**
     * Send update request with the following body and optional params.
     * @param {Object} body Request body/payload to send.
     * @param {Object} options Fetch API options
     * @param {Object} options.query Optional query params to the request URL.
     * @return {Promise} PUT request
     */
    delete (body = {}, options = {}) {
      const { query = {} } = options

      return $ajax({
        url: uri.query(query).toString(),
        method: 'DELETE',
        contentType: 'application/json',
        data: JSON.stringify(body)
      })
    }
  }
}

/**
 * Returns the type classification for the provided entity, indicating whether
 * it is a poll, competition, survey or group.
 * @param {Object} entity Activity entity
 * @return {string|undefined} If no entity type exists, returns undefined.
 */
export function apiType (entity) {
  if (!entity) return

  return entity.type
    ? /^competition|survey$/.test(entity.type) ? entity.type : 'poll'
    : 'group'
}

/**
 * Creates the job payload to send to our PE job endpoint.
 * @param {Array} entities List of entity objects
 * @return {Object}
 */
export function buildJobData (entities = []) {
  const data = {
    poll_ids: [],
    survey_ids: [],
    competition_ids: [],
    group_ids: []
  }

  entities.forEach(entity => {
    const type = apiType(entity)
    data[`${type}_ids`].push(entity.id)
  })

  return data
}
